import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import SyncedTransactionsProvider from './SyncedTransactionsProvider'
import SyncedTransactionsToolbar from './SyncedTransactionsToolbar'
import SyncedTransactionsGrid from './SyncedTransactionsGrid'
import SyncedTransactionsMetrics from './SyncedTransactionsMetrics'

function SyncedTransactionsRenderer ({ config }) {
  return (
    <FadeIn>
      <SyncedTransactionsProvider config={config}>
        <SyncedTransactionsToolbar />
        <SyncedTransactionsMetrics />
        <SyncedTransactionsGrid />
      </SyncedTransactionsProvider>
    </FadeIn>
  )
}

SyncedTransactionsRenderer.propTypes = {
  config: PropTypes.object
}

export default SyncedTransactionsRenderer
